import classNames from 'classnames';
import { PropertyBlock, FlexContainer, Tabs, PropertyPrice } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { usePublicAccount } from 'state';
import { PropertyArea, PropertyDetails } from './bricks';
import styles from './SearchPropertyView.module.scss';

const tabOptions = [
  { key: 'details', value: 'Details', component: PropertyDetails },
  { key: 'area', value: 'Area', component: PropertyArea },
];

const SearchPropertyView = ({ property, className, onClose, onSave }) => {
  const publicAccountDoc = usePublicAccount();
  const [active, setActive] = useState(tabOptions[0].key);
  const handleTabChange = (k) => setActive(k);

  const isSaved = publicAccountDoc.data?.savedPropertyUids.includes(
    property.id
  );

  const actions = [
    {
      key: 'save',
      onClick: onSave,
      icon: isSaved ? 'heartFill' : 'heartOutline',
    },
    { key: 'close', onClick: onClose, icon: 'close' },
  ];

  const ActiveTabComponent = tabOptions.find(
    ({ key }) => active === key
  )?.component;

  return (
    <FlexContainer
      className={classNames(
        styles.SearchPropertyView,
        className,
        `${SearchPropertyView.displayName}`
      )}
      column
    >
      <PropertyBlock
        className={classNames(styles.Item, isSaved && styles.Item__saved)}
        bathroomCount={property.data.bathroomCount}
        bedroomCount={property.data.bedroomCount}
        imageUrls={property.data.imageUrls}
        title={property.data.address?.name}
        subTitle={<PropertyPrice value={property.data.tenancyRentAmount} />}
        actions={actions}
      />
      <FlexContainer column>
        <Tabs value={active} options={tabOptions} onChange={handleTabChange} />
        <FlexContainer column gap className={styles.Body}>
          {ActiveTabComponent ? (
            <ActiveTabComponent property={property} />
          ) : null}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

SearchPropertyView.displayName = 'SearchPropertyView';

export default observer(SearchPropertyView);
